import { apiClient } from './http/client'
import type { AppProfilePayload } from '@/hooks/chat/brandingState'

export type InstanceConfiguration = {
  user_id: string
  tenant_id: string
  instance_id: string
  domain_pack_domain: string
  domain_pack_version: string
  configuration_digest: string
  app_profile: AppProfilePayload
}

const IDENTITY_FIELDS = ['user_id', 'tenant_id', 'instance_id', 'domain_pack_domain',
  'domain_pack_version', 'configuration_digest'] as const
const isRecord = (value: unknown): value is Record<string, unknown> => (
  typeof value === 'object' && value !== null && !Array.isArray(value)
)

/** Validate the wire boundary; instance authorization remains entirely server-owned. */
export async function getCurrentInstanceConfiguration(signal?: AbortSignal): Promise<InstanceConfiguration> {
  const { data } = await apiClient.get<unknown>('/instances/current', { signal })
  if (!isRecord(data) || !IDENTITY_FIELDS.every((key) => typeof data[key] === 'string' && data[key].trim())) {
    throw new TypeError('当前实例配置不可用')
  }
  if (!isRecord(data.app_profile) || !isRecord(data.app_profile.instanceProfile)) {
    throw new TypeError('当前实例配置不可用')
  }
  return data as InstanceConfiguration
}
